import React, { useState, useEffect } from "react";
import Table from "../../../component/table";
import InputField from "../../../component/input-field";
import Select from "react-select";
import "../../../css/theme.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { sanitizeInput } from "../../../utils";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomeModal from "../../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";
import Tippy from "@tippyjs/react";
import {
  assetEntryPerformance,
  getAllActivities,
  getScacData,
  addBookingReference,
  getBookingReferenceList,
  deleteBookingReferenceItem,
} from "../../../redux/actions/todoPerformance";
import { deleteAssetEntryPerformance } from "../../../redux/actions/performance";
import { Customer } from "../../../constant/AuthenticationConstant";
import { checkVisibilitySubscription } from "../../../redux/actions/auth";
import { getTodoPerformanceList } from "../../../redux/actions/publicAssetTracking";
import { getAssets } from "../../../redux/actions/asset";

function AssetTab({ setTab, activity_assignment_id }) {
  // Redux
  const dispatch = useDispatch();
  const {
    assetDataForTracking, 
    assetlist,
    tododata,
    activities,
    tempdata,
    scacData,
    bookingReferenceList,
    performancedata,
    assetdata,
  } = useSelector((state) => state.todoPerformance);
  const { type, email, id, user_departments } = useSelector(
    (state) => state.auth
  );

  // Form Validation Schema
  const validationSchema = Yup.object().shape({
    asset_type: Yup.string().required("This field is required"),
    asset_name: Yup.string().required("This field is required"),
    booking_asset_id: Yup.string(),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      asset_type: "",
      asset_name: "",
      booking_asset_id: "",
      booking_reference_id: bookingReferenceList?.length === 1 ? bookingReferenceList[0].booking_reference_id : ""
    },
    validationSchema,
    onSubmit: (value) => {
      // handleCompleteAssetEntry();
    },
  });

  // State
  const [assetName, setAssetName] = useState([]);
  const [todoList, setTodoList] = useState([]);
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const [shipppingLineOption, setShipppingLineOption] = useState([]);
  const [publicAssetTrackingData, setPublicAssetTrackingData] = useState([]);

  // State for Add Booking Reference
  const [trackingType, setTrackingType] = useState();
  const [trackingReference, setTrackingReference] = useState();
  const [shippingLine, setShippingLine] = useState();
  const [isSubscriptionVisibility, setIsSubscriptionVisibility] =
    useState(false);

  const { assetList } = useSelector((state) => state.assets);

  // Constant
  const dataPerPage = 5;
  const trackingTypeOptions = [
    {
      label: "Bill of Lading",
      value: "BL",
    },
    {
      label: "Carriere Booking Ref.",
      value: "BK",
    },
  ];

  // Function to GET Asset Data
  const publicAsset = () => {
    setLoader(true);
    const request = {
      activity_assignment_id,
      onSuccess: (data) => {
        setPublicAssetTrackingData(data);
        setLoader(false);
      },
      onError: () => {
        setLoader(false);
      },
    };
    dispatch(getTodoPerformanceList(request));
  };

  useEffect(() => {
    if(bookingReferenceList?.length === 1){
      formik.setFieldValue("booking_reference_id", bookingReferenceList[0].booking_reference_id);
    }
  }, [bookingReferenceList])

  useEffect(() => {
    dispatch(getScacData());
    dispatch(
      checkVisibilitySubscription(performancedata.company_id, (value) => {
        setIsSubscriptionVisibility(value);
      })
    );
    dispatch(getAssets((res) => {}));
    getBookingReferenceData();
    publicAsset();
  }, []);

  useEffect(() => {
    if (scacData.length > 0) {
      const modifiedScacData = scacData.map((item) => {
        const obj = {
          label: item.shipping_line_name,
          value: item.scac_code,
        };
        return obj;
      });
      setShipppingLineOption(modifiedScacData);
    }
  }, [scacData]);

  useEffect(() => {
    // if (publicAssetTrackingData) {
      // const assets_based_todolist = publicAssetTrackingData.booking_todos.filter((element) => {
      //   if (type === Customer) {
      //     return (
      //       (element.collaborator_id === id ||
      //         Number(element.activity.is_trackable)) &&
      //       element.activity.based_on === "Container"
      //     );
      //   } else {
      //     return element.activity.based_on === "Container";
      //   }
      // });

      // const assets_based_todolist =
      // activities.filter(
      //     (element) => element.activity.based_on === "Container"
      //   );
      const assets_based_todolist =
        activities?.filter((element) => {
          if (type === Customer) {
            return (
              (element.collaborator_id === id ||
                Number(element.activity.is_trackable)) &&
              element.activity.based_on === "Container"
            );
          } else {
            return element.activity.based_on === "Container";
          }
        });



      if (assetDataForTracking?.length > 0) {
      const asset_filtered_object = {};

        assetDataForTracking?.forEach((element) => {
          const assetType = element.asset_type;

          if (asset_filtered_object[assetType]) {
            // Decrement count if asset_name is exists (Asset already get added)
            if (element.asset_name) {
              asset_filtered_object[assetType].count = asset_filtered_object[
                assetType
              ].count
                ? asset_filtered_object[assetType].count - 1
                : asset_filtered_object[assetType].count;
              asset_filtered_object[assetType].label = asset_filtered_object[
                assetType
              ].count ? (
                `${assetType} (${asset_filtered_object[assetType].count} item remaining)`
              ) : (
                <>
                  {assetType}
                  <Tippy content="You have successfully included all the values corresponding to this asset type.">
                    <span className="fas fa-info-circle fill-current text-indigo-500 cursor-pointer text-sm ml-2"></span>
                  </Tippy>
                </>
              );
              asset_filtered_object[assetType]['booking_asset_id'] = element.booking_asset_id;
            } else {
              // Increment count if asset_type already exists
              asset_filtered_object[assetType].count += 1;
              asset_filtered_object[
                assetType
              ].label = `${assetType} (${asset_filtered_object[assetType].count} item remaining)`;
              asset_filtered_object[assetType].isDisabled = false;
              asset_filtered_object[assetType]['booking_asset_id'] = element.booking_asset_id;
            }
          } else {
            // Initialize count to 0 if asset_name is exists (Asset already get added)
            if (element.asset_name) {
              const assetCheck = assetdata?.find(item => item.asset_type === assetType);
              if(assetCheck){
                asset_filtered_object[assetType] = {
                  label: (
                    <>
                      {assetType}
                      <Tippy content="You have successfully included all the values corresponding to this asset type.">
                        <span className="fas fa-info-circle fill-current text-indigo-500 cursor-pointer text-sm ml-2"></span>
                      </Tippy>
                    </>
                  ),
                  value: assetType,
                  count: 0,
                  isDisabled: false,
                  booking_asset_id: element.booking_asset_id
                };
              }
            } else {
              // Initialize count if asset_type doesn't exist
              asset_filtered_object[assetType] = {
                label: `${assetType} (${1} item remaining)`,
                value: assetType,
                count: 1,
                isDisabled: false,
                booking_asset_id: element.booking_asset_id
              };
            }
          }
        });

        const assetValuesFilter = Object.keys(asset_filtered_object)?.map(item => item);
        // .filter(item => {
        //   // console.log("This is condition: ", typeof asset_filtered_object[item].label === "string", asset_filtered_object[item])
        //   return typeof asset_filtered_object[item].label === "object"
        // } )?

        let assetListValue =  assetList.data ? assetList?.data?.filter((item) => !assetValuesFilter?.includes(item.asset_type)) : [];

        assetListValue = assetListValue?.map((element) => {
          const obj = {
            label: element.asset_type,
            value: element.asset_type,
          };
          return obj;
        });

        setAssetTypeOptions([
          ...Object.values(asset_filtered_object),
          ...assetListValue,
        ]);

        // Creating New Object to store assetperformancedetails along with asset details
        // const newAssetData = assetDataForTracking.map((assetItem) => {
        //   const obj = {};
        //   assets_based_todolist.forEach((todoItem) => {
        //     obj[todoItem.activity.todo_name] =
        //       todoItem.todo_performance_groups.length > 0
        //         ? todoItem.todo_performance_groups[
        //             todoItem.todo_performance_groups.length - 1
        //           ].todo_performances.find(
        //             (assetPerformaceData) =>
        //               assetPerformaceData.value ===
        //               `${assetItem.asset_name}-${assetItem.asset_type}`
        //           )?.date
        //         : "";
        //   });
        //   assetItem.assetPerformanceDetail = obj;
        //   return assetItem;
        // });
        // setAssetName([...newAssetData]);
      } else{

        let assetListValue =  assetList.data ? assetList?.data?.map((element) => { const obj = { label: element.asset_type, value: element.asset_type, }; return obj; }) : [];

        setAssetTypeOptions([
          ...assetListValue
        ]);
      }
      setTodoList(assets_based_todolist);
    // }
  }, [assetDataForTracking, publicAssetTrackingData, assetList]);

  // Function to modify assetTypeOption state after adding or deleting asset
  const modifyAssetTypeOptions = (assetType, type) => {
    setAssetTypeOptions((prev) => {
      return prev.map((element) => {
        if (element.value === assetType) {
          element.count =
            type === "add" ? element.count + 1 : element.count - 1;
          element.label = element.count ? (
            `${element.value} (${element.count} item remaining)`
          ) : (
            <>
              {element.value}
              <Tippy content="You have successfully included all the values corresponding to this asset type.">
                <span className="fas fa-info-circle fill-current text-indigo-500 cursor-pointer text-sm ml-2"></span>
              </Tippy>
            </>
          );
          element.isDisabled = !element.count;
        }
        return element;
      });
    });
  };

  // Function to get updated asset list
  const getAssetList = () => {
    dispatch(
      getAllActivities(activity_assignment_id, (res) => {
        setLoader(false);
      })
    );
  };

  // Function to complete asset entry
  const handleCompleteAssetEntry = () => {
    if (!formik.values.asset_name.trim() || !formik.values.asset_type) {
      return swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`Please provide atleast one asset name for asset type to submit details.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }

    const request = {
      onSuccess: (res) => {
        formik.resetForm();
        if (res.status) {
          getAssetList();
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Asset entry successfully updated.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      },
      onError: (error) => {
        setLoader(false);
        formik.resetForm();
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    const handleFlag = (bool) => {
      setLoader(true);
      let payload = {
        asset_type: formik.values.asset_type,
        activity_assignment_id: activity_assignment_id,
        asset_name: formik.values.asset_name,
        flag: bool,
      };
      
      if(formik.values.booking_asset_id) payload['booking_asset_id'] = formik.values.booking_asset_id;
      if(formik.values.booking_reference_id) payload['booking_reference_id'] = formik.values.booking_reference_id;
      dispatch(assetEntryPerformance(payload, request));
    };
    if (tempdata.length > 0) {
      swal({
        content: (
          <CustomeModal
            type="confirm"
            title="Do you want to update the status of asset?"
            onClick={() => {
              handleFlag(true);
            }}
            onCancel={() => {
              handleFlag(false);
            }}
            buttonText="Yes"
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    } else {
      handleFlag(false);
    }
  };

  // Function to remove added asset and call delete asset API
  const handleDeleteAsset = (assetItem) => {
    if (assetItem.asset_entry_id) {
      setLoader(true);
      // Delete Asset Entry API
      const request = {
        onSuccess: (res) => {
          if (res.status) {
            getAssetList();
          }
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Asset entry successfully deleted.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
        onError: (error) => {
          setLoader(false);
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Something went wrong. Please try again later.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };

      dispatch(deleteAssetEntryPerformance(assetItem.asset_entry_id, request));
    } else {
      // Removing asset_name from assetName State
      setAssetName((prev) => {
        return prev.map((element) => {
          if (element.asset_name === assetItem.asset_name) {
            element.asset_name = "";
          }
          return element;
        });
      });

      // Modifying assetTypeOption state
      modifyAssetTypeOptions(assetItem.asset_type, "add");
    }
  };

  // Function to check user authorized to add and delete asset
  const getPerformActivity = (todoinfo, type, email, id, user_departments) => {
    if (type === "super-admin" || type === "admin") {
      return true;
    }

    if (type === "user") {
      return todoList.some((item) => {
        if (item.user) {
          return item.user?.id === id;
        } else {
          return user_departments.some(
            (department) => department.department_id === item.department?.id
          );
        }
      });
    }

    if (type === "collaborator" || type === "customer") {
      return todoList.some((item) => item?.collaborator_id === id);
    }
  };

  // Function to get Booking Reference
  const getBookingReferenceData = () => {
    const request = {
      activity_assignment_id,
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getBookingReferenceList(request));
  };

  // Function to delete Booking Reference
  const handleDeleteBookingReference = (booking_reference_id) => {
    const request = {
      booking_reference_id,
      onSuccess: () => {
        getBookingReferenceData();
      },
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(deleteBookingReferenceItem(request));
  };

  // Function to add booking reference
  const handleAddBookingReference = () => {
    setLoader(true);

    const request = {
      payload: {
        activity_assignment_id,
        reference: trackingReference,
        reference_type: trackingType.value,
        scac_code: shippingLine.value,
      },
      onSuccess: () => {
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Asset entry successfully updated.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        setTrackingType();
        setTrackingReference();
        setShippingLine();
        getBookingReferenceData();
        getAssetList();
        setLoader(false);
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(addBookingReference(request));
  };

  return loader ? (
    <div
      className="flex justify-center items-center h-screen"
      style={{
        maxHeight: "calc(100vh - 136px)",
      }}
    >
      <div className="overflow-auto max-w-2xl w-full max-h-full py-10">
        <div className="flex justify-center items-center">
          <div class="px-6">
            <svg
              className="animate-spin w-12 h-12 fill-current shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
            </svg>
          </div>
        </div>
        <div className="flex justify-center items-center py-4">
          <h1 className="text-md font-medium">Loading Please wait</h1>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={`sm:pt-2 overflow-y-auto overflow-x-hidden h-screen space-y-8 relative`}
      style={{
        maxHeight: "calc(100vh - 136px)",
      }}
    >
      {/* Asset entry for the SeaRates API */}
      {/* {isSubscriptionVisibility && ( */}
        <div className="space-y-1">
          <h4 className="text-sm leading-3 tracking-tight text-[#535860] font-bold">
            Asset Entry
          </h4>
          <Table
            heads={[
              {
                headName: "Tracking Type",
                isSort: false,
                value: "Tracking Type",
              },
              {
                headName: "Reference",
                isSort: false,
                value: "Reference",
              },
              {
                headName: "Shipping Line",
                isSort: false,
                value: "Shipping Line",
              },
              {
                headName: "Last Update",
                isSort: false,
                value: "Last Update",
              },
              { headName: "Action", isSort: false, value: "Action" },
            ]}
            tClass="table-auto w-full border-separate border-spacing-y-2"
            hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[#F2F8FF]"
            bClass="text-sm"
            thClass="px-2 py-3 whitespace-nowrap text-left last:text-right last:pr-4 font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4"
          >
            <tr className="bg-[#FAFCFF]">
              <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                <Select
                  placeholder="Select Tracking Type"
                  isClearable={true}
                  menuPortalTarget={document.body}
                  className="unresetText w-48"
                  options={trackingTypeOptions}
                  onChange={(e) => setTrackingType(e)}
                  value={trackingType ? trackingType : ""}
                />
              </td>
              <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                <InputField
                  type="text"
                  placeholder="Enter Tracking Reference"
                  wrapperClass="w-48"
                  onChange={(e) => {
                    const value = sanitizeInput(e.target.value);
                    setTrackingReference(value);
                  }}
                  value={trackingReference ? trackingReference : ""}
                />
              </td>
              <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                <Select
                  placeholder="Select Shipping Line"
                  isClearable={true}
                  menuPortalTarget={document.body}
                  className="unresetText w-48"
                  options={shipppingLineOption}
                  onChange={(e) => setShippingLine(e)}
                  value={shippingLine ? shippingLine : ""}
                />
              </td>
              <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                <h6 className="italic text-wrap text-[13px] w-48"></h6>
              </td>
              <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-right text-[#1E293B] rounded-r-md max-w-1/4 truncate space-x-4">
                <div className="space-x-4 flex items-center justify-end">
                  <div className="flex items-center space-x-3">
                    <h6
                      className={`text-sm font-semibold ${
                        shippingLine && trackingReference && trackingType
                          ? "text-indigo-500 cursor-pointer"
                          : "text-indigo-300 pointer-events-none"
                      }  tracking-normal leading-3 pr-4`}
                      onClick={() => handleAddBookingReference()}
                    >
                      Add
                    </h6>
                  </div>
                </div>
              </td>
            </tr>
            {bookingReferenceList.length > 0
              ? bookingReferenceList.map((referenceItem) => {
                  const trackingTypeValue = trackingTypeOptions.find(
                    (item) => item.value === referenceItem.reference_type
                  );
                  const scacCodeValue = shipppingLineOption.find(
                    (item) => item.value === referenceItem.scac_code
                  );
                  return (
                    <tr className="bg-[#FAFCFF]">
                      <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                        <Select
                          placeholder="Select Tracking Type"
                          isClearable={true}
                          menuPortalTarget={document.body}
                          className="unresetText w-48"
                          value={trackingTypeValue ? trackingTypeValue : ""}
                          isDisabled
                        />
                      </td>
                      <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                        <InputField
                          type="text"
                          placeholder="Enter Tracking Reference"
                          wrapperClass="w-48"
                          value={
                            referenceItem?.reference
                              ? referenceItem.reference
                              : ""
                          }
                          disabled={true}
                        />
                      </td>
                      <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                        <Select
                          placeholder="Select Shipping Line"
                          isClearable={true}
                          menuPortalTarget={document.body}
                          className="unresetText w-48"
                          value={scacCodeValue ? scacCodeValue : ""}
                          isDisabled
                        />
                      </td>
                      <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
                        <h6 className="italic text-wrap text-[13px] w-48">
                          {moment(referenceItem.last_updated).format(
                            "DD MMM, YYYY - hh:mm a"
                          )}
                        </h6>
                      </td>
                      <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-right text-[#1E293B] rounded-r-md max-w-1/4 truncate space-x-4">
                        <div className="space-x-4 flex items-center justify-center">
                          <div className="flex items-center">
                            <span
                              className="fa-regular fa-trash-can text-rose-500 cursor-pointer"
                              onClick={() => {
                                swal({
                                  content: (
                                    <CustomeModal
                                      type="delete"
                                      title="Are you sure?"
                                      content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                      onDelete={() =>
                                        handleDeleteBookingReference(
                                          referenceItem.booking_reference_id
                                        )
                                      }
                                    />
                                  ),
                                  buttons: false,
                                  closeOnClickOutside: false,
                                  closeOnEsc: false,
                                });
                              }}
                            ></span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              : null}
          </Table>
        </div>
      {/* )} */}

      {/* Normal Asset Entry for the company which don't have visibility true */}
      <div className="space-y-1">
        {/* {!isSubscriptionVisibility && ( */}
          {/* <h4 className="text-sm leading-3 tracking-tight text-[#535860] font-bold">
            Asset Entry
          </h4> */}
        {/* )} */}

        <Table
          heads={[
            {
              headName: "Reference",
              isSort: false,
              value: "Reference",
            },
            {
              headName: "Asset Type",
              isSort: false,
              value: "Asset Type",
            },
            {
              headName: "Asset Name",
              isSort: false,
              value: "Asset Name",
            },
            { headName: "Action", isSort: false, value: "Action" },
          ]}
          tClass="table-auto w-full border-separate border-spacing-y-2"
          hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[#F2F8FF]"
          bClass="text-sm"
          thClass="px-2 py-3 whitespace-nowrap text-left last:text-right last:pr-4 font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4"
        >
          <tr className="bg-[#FAFCFF]">
            <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
              <Select
                placeholder="Select Reference"
                isClearable={true}
                menuPortalTarget={document.body}
                className="unresetText"
                options={ bookingReferenceList?.map(item => ({label: item.reference, value: item.booking_reference_id})) || []}
                onChange={(e) => {
                  formik.setFieldValue("booking_reference_id", e?.value)
                }}
                value={bookingReferenceList?.find(item => item.booking_reference_id === formik.values.booking_reference_id) ?
                  bookingReferenceList?.filter(item => item.booking_reference_id === formik.values.booking_reference_id).map(ele => ({ label: ele.reference, value: ele.booking_reference_id}))
                  : ""
                }
              />
            </td>
            <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
              <Select
                placeholder="Select Asset Type"
                isClearable={true}
                menuPortalTarget={document.body}
                className="unresetText"
                options={assetTypeOptions}
                onChange={(e) => {
                  formik.setFieldValue("asset_type", e?.value)
                  formik.setFieldValue("booking_asset_id", e?.booking_asset_id)
                }}
                value={
                  assetTypeOptions.find(
                    (element) => element.value === formik.values.asset_type
                  )
                    ? assetTypeOptions.find(
                        (element) => element.value === formik.values.asset_type
                      )
                    : []
                }
              />
            </td>
            <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4">
              <InputField
                type="text"
                placeholder="Enter Asset Name"
                value={formik.values.asset_name}
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  formik.setFieldValue("asset_name", value);
                }}
              />
            </td>
            <td className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-right text-[#1E293B] rounded-r-md max-w-1/4 truncate space-x-4">
              <div className="space-x-4 flex items-center justify-end">
                <div className="flex items-center space-x-3">
                  <h6
                    className={`text-sm font-semibold ${
                      getPerformActivity(
                        tododata,
                        type,
                        email,
                        id,
                        user_departments
                      )
                        ? "text-indigo-500 cursor-pointer"
                        : "text-indigo-300 pointer-events-none"
                    }  tracking-normal leading-3 pr-4`}
                    onClick={() => {
                      getPerformActivity(
                        tododata,
                        type,
                        email,
                        id,
                        user_departments
                      ) && handleCompleteAssetEntry();
                    }}
                  >
                    Add
                  </h6>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>

      {/* Asset entry for the SeaRates API */}

      <div className="space-y-2">
        <h4 className="text-sm leading-3 tracking-tight text-[#535860] font-bold">
          Asset Tracking
        </h4>

        <div className="flex items-center justify-between relative">
          <div className="w-[95%] py-4">
            <div className="w-full flex items-center justify-end">
              {/* Assets Name */}
              <div className="w-[80%] flex items-center space-x-3 flex-nowrap">
                {assetDataForTracking.length > 0 &&
                  assetDataForTracking
                    .slice(page * dataPerPage, page * dataPerPage + dataPerPage)
                    .map((assetItem) => (
                      <div className="rounded p-2 w-[20%] h-[54px] bg-[#F2F8FF] relative">
                        {assetItem.asset_name && (
                          <span
                            className={`fa-solid fa-circle-xmark ${
                              getPerformActivity(
                                tododata,
                                type,
                                email,
                                id,
                                user_departments
                              )
                                ? "cursor-pointer text-rose-500"
                                : "text-rose-300 pointer-events-none"
                            } absolute top-1 right-1 text-xs font-semibold`}
                            onClick={() => {
                              swal({
                                content: (
                                  <CustomeModal
                                    type="delete"
                                    title="Are you sure?"
                                    content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                    onDelete={() =>
                                      handleDeleteAsset(assetItem)
                                    }
                                  />
                                ),
                                buttons: false,
                                closeOnClickOutside: false,
                                closeOnEsc: false,
                              });
                            }}
                          ></span>
                        )}

                        <div
                          title={assetItem.asset_type}
                          className="text-center font-normal text-xs leading-4 text-[##1E293B]"
                        >
                          {assetItem.asset_type}
                        </div>
                        <div
                          title={assetItem.asset_name}
                          className="text-center text-xs font-semibold leading-4 text-[##1E293B] truncate"
                        >
                          {assetItem.asset_name}
                        </div>
                      </div>
                    ))}
              </div>
            </div>
            <div className="py-4 w-full flex justify-between">
              {/* List of To Do */}
              <div className="w-[20%]">
                {todoList.length > 0 &&
                  todoList.map((todoItem, index) => {
                    if (index !== todoList.length - 1) {
                      return (
                        <>
                          <div className="h-[19px] flex justify-start items-center w-full">
                            <h4
                              title={todoItem.activity.todo_name}
                              className="text-sm text-[#1E293B] font-semibold leading-4 max-w-3/4 truncate"
                            >
                              {todoItem.activity.todo_name}
                            </h4>
                          </div>
                          <div className="invisible h-10"></div>
                        </>
                      );
                    }
                    return (
                      <div className="h-[19px] flex justify-start items-center w-full">
                        <h4
                          title={todoItem.activity.todo_name}
                          className="text-sm text-[#1E293B] font-semibold leading-4 max-w-3/4 truncate"
                        >
                          {todoItem.activity.todo_name}
                        </h4>
                      </div>
                    );
                  })}
              </div>

              {/* Status of Assets based on Asset Type */}
              {/* <div className="w-[80%] flex items-center space-x-3 flex-nowrap">
                {assetName.length > 0 &&
                  assetName
                    .slice(page * dataPerPage, page * dataPerPage + dataPerPage)
                    .map((assetItem) => (
                      <div className="w-[20%] flex justify-center relative">
                        <div className="flex flex-col items-center">
                          {todoList.length > 0 &&
                            todoList.map((todoItem, index) => {
                              const assetStatus = `${assetItem.asset_name}-${assetItem.asset_type}`
                                todoItem.todo_performance_groups[
                                  todoItem.todo_performance_groups.length - 1
                                ]?.todo_performances.find(
                                  (data) =>
                                    data.value ===
                                    `${assetItem.asset_name}-${assetItem.asset_type}`
                                );
                              if (index !== todoList.length - 1) {
                                return (
                                  <>
                                    <div
                                      className={`rounded-full border-3 w-[19px] h-[19px] relative ${
                                        todoItem?.performance_type === "save" ||
                                        todoItem?.performance_type ===
                                          "complete"
                                          ? "border-indigo-500"
                                          : "border-[#D9E9FF]"
                                      }`}
                                    >
                                      <div
                                        className={`absolute top-0 left-0 h-full w-full ${
                                          todoItem?.performance_type ===
                                          "complete"
                                            ? "bg-indigo-500"
                                            : "bg-[#D9E9FF]"
                                        } ${
                                          todoItem?.performance_type === "save"
                                            ? "w-1/2 bg-indigo-500"
                                            : ""
                                        }`}
                                      ></div>
                                    </div>

                                    <div
                                      className={`flex-auto border ${
                                        todoItem?.performance_type === "save" ||
                                        todoItem?.performance_type ===
                                          "complete"
                                          ? "border-indigo-500"
                                          : "border-[#D9E9FF]"
                                      } h-10 w-0 transition duration-500 ease-in-out`}
                                    ></div>
                                  </>
                                );
                              }
                              return (
                                <div
                                  className={`rounded-full border-3 w-[19px] h-[19px] relative ${
                                    todoItem?.performance_type === "save" ||
                                    todoItem?.performance_type === "complete"
                                      ? "border-indigo-500"
                                      : "border-[#D9E9FF]"
                                  }`}
                                >
                                  <div
                                    className={`absolute top-0 left-0 h-full w-full ${
                                      todoItem?.performance_type === "complete"
                                        ? "bg-indigo-500"
                                        : "bg-[#D9E9FF]"
                                    } ${
                                      todoItem?.performance_type === "save"
                                        ? "w-1/2 bg-indigo-500"
                                        : ""
                                    }`}
                                  ></div>
                                </div>
                              );
                            })}
                        </div>
                        <div className="absolute top-0 left-[65%]">
                          {todoList.length > 0 &&
                            todoList.map((todoItem, index) => {
                              if (index !== todoList.length - 1) {
                                return (
                                  <>
                                    <div className="h-[19px] w-[63px]">
                                      {(todoItem?.performance_type === "save" ||
                                        todoItem?.performance_type ===
                                          "complete") && (
                                        <>
                                          <h4 className="text-[10px] text-[#808080] font-bold leading-4">
                                            {moment(
                                              todoItem.performance_date
                                            ).format("DD MMM,YYYY")}
                                          </h4>
                                          <h6 className="text-[10px] text-[#808080] font-normal leading-4">
                                            {moment(todoItem.date).format(
                                              "hh:mm A"
                                            )}
                                          </h6>
                                        </>
                                      )}
                                    </div>
                                    <div className="invisible h-10"></div>
                                  </>
                                );
                              }
                              return (
                                <div className="h-[19px] w-[63px]">
                                  {(todoItem.status === "completed" ||
                                    todoItem.status ===
                                      "completed with delay") &&
                                    todoItem.performance_based_on ===
                                      `${assetItem.asset_name}-${assetItem.asset_type}` && (
                                      <>
                                        <h4 className="text-[10px] text-[#808080] font-bold leading-4">
                                          {moment(
                                            assetItem.assetPerformanceDetail[
                                              todoItem.activity.todo_name
                                            ]
                                          ).format("DD MMM,YYYY")}
                                        </h4>
                                        <h6 className="text-[10px] text-[#808080] font-normal leading-4">
                                          {moment(
                                            assetItem.assetPerformanceDetail[
                                              todoItem.activity.todo_name
                                            ]
                                          ).format("hh:mm A")}
                                        </h6>
                                      </>
                                    )}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    ))}
              </div> */}
              <div className="w-[80%] flex items-center space-x-3 flex-nowrap">
                {assetDataForTracking.length > 0 &&
                  assetDataForTracking
                    .slice(page * dataPerPage, page * dataPerPage + dataPerPage)
                    .map((assetItem) => (
                      <div className="w-[20%] flex justify-center relative">
                        <div className="flex flex-col items-center">
                          {todoList.length > 0 &&
                            todoList.map((todoItem, index) => {
                              const assetStatus = publicAssetTrackingData.find((data) => todoItem.activity.activity_id === data.activity_id && data.based_on === `${assetItem.asset_name}-${assetItem.asset_type}`);
                              // console.log("assetStatus: ", assetStatus, index)
                                // todoItem.todo_performance_groups[
                                //   todoItem.todo_performance_groups.length - 1
                                // ]?.todo_performances.find(
                                //   (data) =>
                                //     data.value ===
                                //     `${assetItem.asset_name}-${assetItem.asset_type}`
                                // );
                              if (index !== todoList.length - 1) {
                                return (
                                  <>
                                    <div
                                      className={`rounded-full border-3 w-[20px] h-[20px] relative ${
                                        assetStatus?.type === "save" ||
                                        assetStatus?.type === "complete"
                                          ? "border-indigo-500"
                                          : "border-[#D9E9FF]"
                                      }`}
                                    >
                                      <div
                                        className={`absolute top-0 left-0 h-full w-full ${
                                          assetStatus?.type === "complete"
                                            ? "bg-indigo-500 rounded"
                                            : "bg-[#D9E9FF]"
                                        } ${
                                          assetStatus?.type === "save"
                                            ? "w-1/2 bg-indigo-500 rounded-s"
                                            : ""
                                        }`}
                                      ></div>
                                    </div>

                                    <div
                                      className={`flex-auto border ${
                                        assetStatus?.type === "save" ||
                                        assetStatus?.type === "complete"
                                          ? "border-indigo-500"
                                          : "border-[#D9E9FF]"
                                      } h-10 w-0 transition duration-500 ease-in-out`}
                                    ></div>
                                  </>
                                );
                              }
                              return (
                                <div
                                  className={`rounded-full border-3 w-[20px] h-[20px] relative ${
                                    assetStatus?.type === "save" ||
                                    assetStatus?.type === "complete"
                                      ? "border-indigo-500"
                                      : "border-[#D9E9FF]"
                                  }`}
                                >
                                  <div
                                    className={`absolute top-0 left-0 h-full w-full ${
                                      assetStatus?.type === "complete"
                                        ? "bg-indigo-500 rounded"
                                        : "bg-[#D9E9FF]"
                                    } ${
                                      assetStatus?.type === "save"
                                        ? "w-1/2 bg-indigo-500 rounded-s"
                                        : ""
                                    }`}
                                  ></div>
                                </div>
                              );
                            })}
                        </div>
                        <div className="absolute top-0 left-[65%]">
                          {todoList.length > 0 &&
                            todoList.map((todoItem, index) => {
                              // if (index !== todoList.length - 1) {
                                const assetStatus = 
                                publicAssetTrackingData.find((data) => todoItem.activity.activity_id === data.activity_id && data.based_on === `${assetItem.asset_name}-${assetItem.asset_type}`);
                                
                                // todoItem.performance_based_on === assetItem.based_on && assetItem;
                                  // todoItem.todo_performance_groups[
                                  //   todoItem.todo_performance_groups.length - 1
                                  // ]?.todo_performances.find(
                                  //   (data) =>
                                  //     data.value ===
                                  //     `${assetItem.asset_name}-${assetItem.asset_type}`
                                  // );
                                return (
                                  <>
                                    <div className="h-[19px] w-[63px]">
                                      {(assetStatus?.type === "save" ||
                                        assetStatus?.type === "complete") && (
                                        <>
                                          <h4 className="text-[10px] text-[#808080] font-bold leading-4">
                                            {moment(assetStatus?.date).format(
                                              "DD MMM,YYYY"
                                            )}
                                          </h4>
                                          <h6 className="text-[10px] text-[#808080] font-normal leading-4">
                                            {moment(assetStatus?.date).format(
                                              "hh:mm A"
                                            )}
                                          </h6>
                                        </>
                                      )}
                                    </div>
                                    <div className="invisible h-10"></div>
                                  </>
                                );
                              // }
                              // console.log("todoItem", todoItem)
                              // return (
                              //   <div className="h-[19px] w-[63px]">
                              //     {(todoItem.status === "completed" ||
                              //       todoItem.status ===
                              //         "completed with delay") &&
                              //       todoItem.todo_performance_groups[
                              //         todoItem.todo_performance_groups.length -
                              //           1
                              //       ].todo_performances.some(
                              //         (data) =>
                              //           data.value ===
                              //           `${assetItem.asset_name}-${assetItem.asset_type}`
                              //       ) && (
                              //         <>
                              //           <h4 className="text-[10px] text-[#808080] font-bold leading-4">
                              //             {moment(
                              //               assetItem.assetPerformanceDetail[
                              //                 todoItem.activity.todo_name
                              //               ]
                              //             ).format("DD MMM,YYYY")}
                              //           </h4>
                              //           <h6 className="text-[10px] text-[#808080] font-normal leading-4">
                              //             {moment(
                              //               assetItem.assetPerformanceDetail[
                              //                 todoItem.activity.todo_name
                              //               ]
                              //             ).format("hh:mm A")}
                              //           </h6>
                              //         </>
                              //       )}
                              //   </div>
                              // );
                            })}
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          </div>
          {/* Angular bracket icon  */}
          <div className="flex items-center space-x-2 absolute top-7 right-0">
            <span
              className={`fa-solid fa-angle-left text-base ${
                page === 0
                  ? "fill-current text-slate-400 pointer-events-none"
                  : "cursor-pointer"
              }`}
              onClick={(e) => setPage(page - 1)}
            ></span>
            <span
              className={`fa-solid fa-angle-right text-base ${
                Math.ceil(assetDataForTracking.length / dataPerPage) === page + 1
                  ? "fill-current text-slate-400 pointer-events-none"
                  : "cursor-pointer"
              }`}
              onClick={(e) => setPage(page + 1)}
            ></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssetTab;
